import React from 'react';

import CountryDetails from '../../components/CountryDetails';

const CountryInfos = () => {
  return (
    <div>
      <CountryDetails />
    </div>
  );
};

export default CountryInfos;
